import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { ProtectedRoute } from "./ProtectedRoute";
import { RoleRoute } from "./RoleRoute";
import { LoginPage } from "@/features/auth/LoginPage";
import { ForgotPasswordPage } from "@/features/auth/ForgotPasswordPage";
import { ResetPasswordPage } from "@/features/auth/ResetPasswordPage";
import { ChangePasswordPage } from "@/features/auth/ChangePasswordPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { CustomersPage } from "@/features/customers/CustomersPage";
import { ComplaintsPage } from "@/features/complaints/ComplaintsPage";
import { EmployeesPage } from "@/features/employees/EmployeesPage";
import { ReportsPage } from "@/features/reports/ReportsPage";

const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: "/", element: <DashboardPage /> },
          { path: "/customers", element: <CustomersPage /> },
          { path: "/complaints", element: <ComplaintsPage /> },
          { path: "/change-password", element: <ChangePasswordPage /> },
          {
            element: <RoleRoute allow={["ADMIN"]} />,
            children: [
              { path: "/employees", element: <EmployeesPage /> },
              { path: "/reports", element: <ReportsPage /> },
            ],
          },
        ],
      },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
